import { render, staticRenderFns } from "./CollectionGeneralTranslateForm.vue?vue&type=template&id=257f51a0&scoped=true&"
import script from "./CollectionGeneralTranslateForm.vue?vue&type=script&lang=js&"
export * from "./CollectionGeneralTranslateForm.vue?vue&type=script&lang=js&"
import style0 from "./CollectionGeneralTranslateForm.vue?vue&type=style&index=0&id=257f51a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257f51a0",
  null
  
)

export default component.exports